import { RootState } from 'redux/schemas';
import { LearnerFinalSummaryStatus } from 'redux/schemas/app/learner-final-summary';

export const getLearnerFinalSummaryState = (state: RootState) => state.app.learnerFinalSummary;

export const getLearnerFinalSummaryReport = (state: RootState) => state.app.learnerFinalSummary.report;

export const getLearnerFinalSummaryStatus = (state: RootState) => state.app.learnerFinalSummary.status;

export const isLearnerTakeawayVisible = (state: RootState) => state.app.learnerFinalSummary.show;

export const isLearnerFinalSummaryReady = (state: RootState) => (
  state.app.learnerFinalSummary.status === LearnerFinalSummaryStatus.Ready
  && !!state.app.learnerFinalSummary.report
);

export const isLearnerFinalSummaryGenerating = (state: RootState) => {
  const { status } = state.app.learnerFinalSummary;
  return status === LearnerFinalSummaryStatus.Queued
    || status === LearnerFinalSummaryStatus.Processing;
};

export const hasLearnerFinalSummaryError = (state: RootState) => (
  state.app.learnerFinalSummary.status === LearnerFinalSummaryStatus.Failed
);
